module.exports = __webpack_public_path__ + "static/media/sos.abb98a53.png";